module.exports = __webpack_public_path__ + "img/kxh-code.4ca27478.png";